import { ColumnSort, FiltersRequestResponse, Range } from '@spo/logic';
import { apiSuperModels } from '@spo/services/api';
import { SpoUserSettingsResponse } from '@spo/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { buildFiltersParams } from '../utils/filters';
import { sleep } from '../utils/sleep';

export const usePersonalOfferTable = (
  userConfig: SpoUserSettingsResponse | undefined,
  range: Range,
  columnSort: ColumnSort,
  selectedFilters: FiltersRequestResponse,
  smIds: string[] = [],
  debounce = false,
) => {
  return useQuery({
    queryKey: [
      'superModelsTableDataWithLabels',
      userConfig,
      range,
      columnSort,
      selectedFilters,
      smIds,
    ],
    queryFn: async ({ signal }) => {
      const builtFilters = buildFiltersParams(userConfig, selectedFilters);
      if (debounce) {
        await sleep(400);
      }
      if (!signal?.aborted) {
        return apiSuperModels.getPersonalOfferSM({
          filters: builtFilters,
          smIds,
          columnSort,
          offerDate: userConfig?.offerDate,
          range,
        });
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!userConfig && !userConfig?.needRedirect,
  });
};
